var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center mb-7 mx-2",class:'mt-4',staticStyle:{"width":"80px"}},[_c('b-img',{class:'img-extension',style:({ opacity: _vm.hire ? 1 : 0.5 }),attrs:{"src":_vm.getExtensionIcon,"alt":""}}),_c('div',{class:'mt-4',staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.extension().getName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }